import * as yup from "yup";

import { Translations, i18n } from "@i18n";
import { AddBeneficiaryFormValues } from "./types";

export const validationSchema: yup.SchemaOf<AddBeneficiaryFormValues> = yup.object().shape({
  firstName: yup.string().required(i18n.t(Translations.AddChildRouteFirstNameRequired)),
  lastName: yup.string().required(i18n.t(Translations.AddChildRouteLastNameRequired)),
});
